/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class Annotation {
    getFixupPrototypeFunction() { return Annotation.fixupPrototype; }

    static newInstance(model: Partial<Annotation>): Annotation {
        let obj = Object.assign(new Annotation(), model);
        Annotation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<Annotation>): Annotation {
        if (!model) return null;
        return Annotation.newInstance(<Annotation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: Annotation) {
        if (!obj) return;

        models.Annotation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: Annotation): boolean {
        Object.setPrototypeOf(obj, Annotation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.range) {
            models.AnnotationRange.fixupPrototype(this.range);
        }
    }

    /**
     * What the annotation is anchored to
     */
    kind: models.AnnotationKind;

    /**
     * Id of the annotated element, as assigned by the backend's deterministic id pass
     */
    element_id: string;

    /**
     * Lower-case tag name of the annotated element
     */
    tag: string;

    /**
     * Visible text of the element or the selected text, plain text, truncated by the client
     */
    text: string;

    /**
     * Nearest preceding heading, so the agent can re-anchor when ids shift
     */
    heading: string;

    /**
     * What the user wants changed at this anchor
     */
    instruction: string;

    /**
     * Selection boundaries; present only when kind is text-range
     */
    range: models.AnnotationRange;

    /**
     * First-cell text of the annotated row; present only when kind is table-cell
     */
    row_label: string;

    /**
     * Header text of the annotated column; present only when kind is table-cell
     */
    column_label: string;

}
